import { Flex, Select, Text } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'

import { registerModeList } from '../constant'

interface PerfectWayProps {
    value: string
    onChange: (value: string) => void
}

const PerfectWay = React.forwardRef<HTMLDivElement, PerfectWayProps>(({ value, onChange }, ref) => {
    return (
        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center" ref={ref}>
            <Text>完善内容</Text>

            <Flex>
                <Select value={value} style={{ width: 180 }} options={registerModeList} onChange={onChange} />
            </Flex>
        </ListItem4ByecodeUi>
    )
})

export default React.memo(PerfectWay)
